import { createFeatureSelector, createSelector } from '@ngrx/store'
import { MB_WISHLIST_FEATURE, WishlistState } from '../state'

export const getMbWishlistState = createFeatureSelector<WishlistState>(MB_WISHLIST_FEATURE)

export const getDefaultWishlist = createSelector(
  getMbWishlistState,
  (state: WishlistState) => state.defaultWishlist
)
